<template>
  <div
    id="parallaxscrolling"
    style="background-color: white"
    :style="{ 'pointer-events': !gesture ? 'auto' : 'none' }"
  >
    <img :src="isamnet" style="width: 100%" />
    <div id="ucf-content">
      <div id="main-wrapper">
        <div id="main-container">
          <div class="ucf-carousel-wrapper" style="overflow: hidden;">
            <div class="ucf-carousel-container"
              :style="{
                width: `${imageAreaW}px`,
                margin: 'auto',
                background: 'black',
                position: 'relative',
              }"
            >
              <div
                :class="['item']"
                v-for="(image, index) in creative.images"
                :key="index"
                :style="{
                  width: `${imageAreaW}px`,
                  height: `${imageAreaH}px`,
                  zIndex: `${(creative.images.length + 10) - index}`,
                  overflow: 'hidden',
                  position: 'relative',
                }"
              >
                <a
                  v-if="image.material_type === CONSTANT.MATERIAL_TYPE.IMAGES"
                  :href="creative.landing_page"
                  target="_blank"
                  :style="{
                    width: `${imageW}px`,
                    height: `${imageH}px`,
                  }"
                >
                  <img
                    :src="image.url"
                    :style="{
                      width: `${imageW}px`,
                      height: `${imageH}px`,
                      position: `absolute`,
                      bottom: `0px`,
                      left: `50%`,
                      transform: `translateX(-50%)`
                    }"
                  />
                </a>
                <div
                  class="overlay-iframe"
                  v-if="image.material_type === CONSTANT.MATERIAL_TYPE.HTML"
                  @click="openLandingPage"
                  :style="{
                    width: `${imageW}px`,
                    height: `${imageH}px`,
                    position: `absolute`,
                    bottom: `0px`,
                    left: `50%`,
                    transform: `translateX(-50%)`,
                    zIndex: 1,
                  }"
                ></div>
                <div
                  v-if="image.material_type === CONSTANT.MATERIAL_TYPE.HTML"
                  :style="{
                    width: `${imageW}px`,
                    height: `${imageH}px`,
                    position: `absolute`,
                    bottom: `0px`,
                    left: `50%`,
                    transform: `translateX(-50%)`
                  }">
                  <iframe
                  :class="`h5-${index}`"
                  :src="image.url"
                  v-if="image.material_type === CONSTANT.MATERIAL_TYPE.HTML"
                  scrolling="no"
                  frameborder="0"
                  allowfullscreen="true"
                  :style="{
                    margin: '0',
                    border: 'none',
                    overflow: 'hidden',
                    display: 'block',
                    backgroundColor: 'black',
                    width: '320px',
                    height: '400px',
                    transformOrigin: '0 0',
                    transform: `scale(${iframeScale})`,
                  }"
                />
                </div>
              </div>
              <div id="ucf-video-container"
                :style="{
                  width: `100%`,
                  height: `${videoHeight}px`,
                  transform: `translateY(${videoTranslateY}px)`,
                  zIndex: `1000 !important`,
                  position: `relative`,
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/parallaxScrolling/bg2.png"
      style="width: 100%"
    />
  </div>
</template>

<script>
import mixPreview from '@/components/mixins/preview.js';
import mixMobile from '@/components/mixins/mobile.js';
import mixOutstream from '@/components/mixins/outstream.js';
import mixYoutubePlayer from '@/components/mixins/youtubePlayer.js';
import FacebookPlayer from '@/components/mixins/facebookPlayer.js';
export default {
  data() {
    // 從 creative 讀取 video 尺寸，使用預設值
    const videoWidth = this.creative.video_width || 320;
    const videoHeight = this.creative.video_height || 180;
    return {
      index: 0,
      len: this.creative.images.length,
      videoWidth: videoWidth,
      videoHeight: videoHeight,

      imageW: 320,
      imageH: 400,
      imageAreaW: 320,
      imageAreaH: 400,
      player: null,
      isLoad: false,
      verticalAlign: this.creative.vertical_align || "bottom",
      videoTranslateY: 1000,
      iframeScale: 1,
      imgOriginWidth: 320,
      imgOriginHeight: 400,
      videoOriginWidth: videoWidth,
      videoOriginHeight: videoHeight,
    };
  },
  computed: {
    position() {
      let layoutObj = {}
      layoutObj.position = 'relative';
      layoutObj['z-index'] = 1000;
      layoutObj.top = -this.imageAreaH*2 + 'px';
      return layoutObj;
    },
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = 'https://cdn.aralego.net/rich_media/assets';
      if (domain === 'prism.amnet.tw') {
        isAmnet += '/amnet/bg.png';
      } else {
        isAmnet += '/parallaxScrolling/bg1.png';
      }
      return isAmnet;
    },
  },
  async mounted() {
    this.viewport();
    await this.$nextTick();
    setTimeout(() => {
      this.handleResize();

      if (this.creative.vast_xml) {
        this.creative.vast_xml = this.removeTrackingEvent(
          this.creative.vast_xml
        );
        const target = document.querySelector('#ucf-video-container');
        this.addPlayer(target, this.videoWidth, this.videoHeight);
        this.video_div.lastElementChild.style.margin = 'auto';
      } else if (this.creative.youtube_video_id) {
        let tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        const target = document.querySelector('#ucf-video-container');
        window.onYouTubeIframeAPIReady = () => {
          const videoId = this.creative.youtube_video_id;
          this.player = this.addYtPlayer(
            target,
            videoId,
            this.videoWidth.toString(),
            this.videoHeight.toString()
          );
          this.video_div.removeAttribute('style');
          this.youtubeElm = this.video_div;
          this.setStyle(this.youtubeElm.lastElementChild, {
            width: `${this.videoWidth}px`,
            height: `${this.videoHeight}px`,
            margin: 'auto',
            display: 'block',
          });
        };
      } else if (this.creative.facebook_video_url) {
        const fbStream = new FacebookPlayer(
          this.creative.facebook_video_url,
          this.videoWidth,
          this.videoHeight,
          this.creative.facebook_video_landing_page,
          true,
        );
        const fbStreamEle = fbStream.init();
        const fbTarget = document.querySelector('#ucf-video-container');
        fbTarget.appendChild(fbStreamEle);
        this.fbStreamElm = fbStreamEle;
        let clickDiv = fbStreamEle.firstElementChild;
        clickDiv.style.cssText = "";
        this.setStyle(this.fbStreamElm, {
          width: `${this.videoWidth}px`,
          height: `${this.videoHeight}px`,
          margin: 'auto',
          display: 'block',
        });
        this.setStyle(clickDiv, {
          width: `${this.videoWidth}px`,
          height: `${this.videoHeight}px`,
          margin: 'auto',
          display: 'block',
          "z-index": 100,
          position: 'absolute',
        });
        let fbVideoElm = document.querySelectorAll(`.fb-video`)[0];
        this.setStyle(fbVideoElm, {
          width: `${this.videoWidth}px`,
          height: `${this.videoHeight}px`,
        });
        this.setStyle(fbVideoElm.lastElementChild, {
          width: `${this.videoWidth}px`,
          height: `${this.videoHeight}px`,
        });
        this.setStyle(fbVideoElm.lastElementChild.lastElementChild, {
          width: `${this.videoWidth}px`,
          height: `${this.videoHeight}px`,
        });
      }

      this.scroll();
      this.addEvent(window, 'scroll', this.scroll);
      if (this.len > 1) {
        const wrapper = document.querySelector('.ucf-carousel-wrapper');
        const container = document.querySelector('.ucf-carousel-container');
        this.handleTouch(wrapper);
        this.handleAnimate(container);
      }
      this.isLoad = true;
    }, 200);
    this.creative.images.forEach((image, index) => {
      let millisecond = image.millisecond;
      if (image.material_type === CONSTANT.MATERIAL_TYPE.HTML && millisecond) {
        let times = image.times;
        if (times > 0) {
          times = times - 1;
        }
        let timer = setInterval(() => {
          if (times !== 0) {
            let h5 = document.querySelector(`.h5-${index}`);
            h5.src = h5.src;
          } else {
            clearInterval(timer);
          }
          if (times !== -1) {
            times = times - 1;
          }
        }, millisecond);
      }
    });
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.removeEvent(window, 'scroll', this.scroll);
  },
  mixins: [mixPreview, mixMobile, mixOutstream, mixYoutubePlayer],
  methods: {
    scroll() {
      if (!this.isLoad) {
        return;
      }
      let items = document.querySelectorAll(`.item`);
      let content = document.querySelector('#ucf-content');
      let imgRoot = document.querySelectorAll('.ucf-carousel-container')[0];
      let top = content.getBoundingClientRect().top;

      imgRoot.style.top = -top +'px';
      items.forEach((imageElm, index) => {
        let translateY = this.imageAreaH*index - ((this.verticalAlign == "top") ? this.videoHeight : 0);
        let deg = (top < 0 && -top > (index) * this.imageAreaH && index+1 <items.length) ? ((-top - index * this.imageAreaH) / this.imageAreaH * 45) : 0;
        let translateX = (top < 0 && -top > (index) * this.imageAreaH && index+1 <items.length) ? ((-top - index * this.imageAreaH) / this.imageAreaH * document.documentElement.clientWidth*items.length) : 0;
        items[index].style.transform = `rotate(${deg}deg) translateX(${-translateX}px) translateY(${-translateY}px)`;
      });

    },
    messageHandler(e) {
      const frame = document.querySelector('iframe');
      switch (e.data.type) {
        case 'close':
          frame.style.display = 'none';
          break;
        case 'ready':
          this.setPlayerConfig();
          this.initialAd(this.creative.vast_xml);
          if (this.len == 1) this.videoIO.observe(this.video_div);
          break;
        case 'Loaded':
          frame.style.display = 'block';
          this.onVideoPlay();
          this.removeVideoClickDiv();
          break;
        case 'Start':
          this.showToolBar();
          break;
        case 'error':
          this.$notify.error({
            title: 'Error',
            message: e.data.error,
            position: 'bottom-right',
            offset: 20,
          });
          break;
        default:
          break;
      }
    },
    openLandingPage() {
      window.open(this.creative.landing_page, '_blank');
    },
    // 獲取視窗尺寸
    getViewportSize() {
      return {
        width: document.documentElement.clientWidth || window.document.documentElement.clientWidth || window.document.body.clientWidth,
        height: document.documentElement.clientHeight || window.document.documentElement.clientHeight || window.document.body.clientHeight,
      };
    },
    // 計算視頻尺寸（根據直向/橫向模式）
    calculateVideoDimensions(isPortrait, vw) {
      if (isPortrait) {
        const ratio = vw / this.videoOriginWidth;
        return {
          width: Math.round(this.videoOriginWidth * ratio),
          height: Math.round(this.videoOriginHeight * ratio),
        };
      } else {
        return {
          width: this.videoOriginWidth,
          height: this.videoOriginHeight,
        };
      }
    },
    // 計算圖片區域尺寸
    calculateImageArea(vw, vh, videoHeight) {
      return {
        width: vw,
        height: vh - videoHeight,
      };
    },
    // 計算圖片尺寸（保持寬高比）
    calculateImageDimensions(imageAreaW, imageAreaH) {
      const imageAspectRatio = this.imgOriginWidth / this.imgOriginHeight;
      const areaAspectRatio = imageAreaW / imageAreaH;
      const imageW = imageAspectRatio > areaAspectRatio 
        ? imageAreaW 
        : (imageAspectRatio * imageAreaH);
      const imageH = (this.imgOriginHeight / this.imgOriginWidth) * imageW;
      return { width: imageW, height: imageH };
    },
    // 計算視頻位置和 iframe 縮放比例
    calculateVideoPosition(imageAreaH, imageH) {
      const videoTranslateY = this.verticalAlign === 'bottom' 
        ? -imageAreaH * (this.len - 1) 
        : -imageAreaH * this.len;
      const iframeScale = imageH / this.imgOriginHeight;
      return { videoTranslateY, iframeScale };
    },
    // 更新視頻播放器尺寸（支持 VAST、Facebook、YouTube）
    updateVideoPlayerSize() {
      if (this.creative.vast_xml && this.video_div) {
        const frame = this.video_div.lastElementChild;
        frame.style.width = this.videoWidth + 'px';
        frame.style.height = this.videoHeight + 'px';
        frame.contentWindow.postMessage({
          type: "setSize",
          width: this.videoWidth,
          height: this.videoHeight
        }, "*");
      } else if (this.creative.facebook_video_url && this.fbStreamElm) {
        const fbVideoElm = document.querySelectorAll(`.fb-video`)[0];
        const clickDiv = this.fbStreamElm.firstElementChild;
        const videoSize = {
          width: `${this.videoWidth}px`,
          height: `${this.videoHeight}px`,
        };
        this.setStyle(this.fbStreamElm, {
          ...videoSize,
          margin: 'auto',
          display: 'block',
        });
        this.setStyle(clickDiv, {
          ...videoSize,
          margin: 'auto',
          display: 'block',
        });
        if (fbVideoElm) {
          this.setStyle(fbVideoElm, videoSize);
          if (fbVideoElm.lastElementChild) {
            this.setStyle(fbVideoElm.lastElementChild, videoSize);
            if (fbVideoElm.lastElementChild.lastElementChild) {
              this.setStyle(fbVideoElm.lastElementChild.lastElementChild, videoSize);
            }
          }
        }
      } else if (this.youtubeElm) {
        const ytFrame = this.youtubeElm.lastElementChild;
        this.setStyle(this.youtubeElm, {
          width: `${this.videoWidth}px`,
          height: `${this.videoHeight}px`,
          display: 'block',
          margin: 'auto',
        });
        if (ytFrame) {
          this.setStyle(ytFrame, {
            width: `${this.videoWidth}px`,
            height: `${this.videoHeight}px`,
          });
        }
      }
    },
    // 處理視窗大小變化，重新計算所有尺寸和位置
    handleResize() {
      const content = document.querySelector('#ucf-content');
      const items = document.querySelectorAll(`.item`);
      const { width: vw, height: vh } = this.getViewportSize();
      const isPortrait = vh > vw;
      
      // 計算視頻尺寸
      const videoDims = this.calculateVideoDimensions(isPortrait, vw);
      this.videoWidth = videoDims.width;
      this.videoHeight = videoDims.height;
      
      // 計算圖片區域
      const imageArea = this.calculateImageArea(vw, vh, this.videoHeight);
      this.imageAreaW = imageArea.width;
      this.imageAreaH = imageArea.height;
      
      // 計算圖片尺寸
      const imageDims = this.calculateImageDimensions(this.imageAreaW, this.imageAreaH);
      this.imageW = imageDims.width;
      this.imageH = imageDims.height;
      
      // 計算視頻位置
      const videoPos = this.calculateVideoPosition(this.imageAreaH, this.imageH);
      this.videoTranslateY = videoPos.videoTranslateY;
      this.iframeScale = videoPos.iframeScale;
      
      // 更新內容區域尺寸
      this.adHeight = this.imageAreaH * this.creative.images.length + this.videoHeight;
      this.setStyle(content, {
        height: this.adHeight + 'px',
        width: vw + 'px',
      });

      // 優化 DOM 查詢 - 在循環外查詢一次，避免重複查詢
      const contentTop = content.getBoundingClientRect().top;
      items.forEach((imageElm, index) => {
        const translateY = this.imageAreaH * index - ((this.verticalAlign === "top") ? this.videoHeight : 0);
        const shouldAnimate = contentTop < 0 && -contentTop > index * this.imageAreaH && index + 1 < items.length;
        const deg = shouldAnimate ? ((-contentTop - index * this.imageAreaH) / this.imageAreaH * 45) : 0;
        const translateX = shouldAnimate 
          ? ((-contentTop - index * this.imageAreaH) / this.imageAreaH * document.documentElement.clientWidth * items.length) 
          : 0;
        imageElm.style.transform = `rotate(${deg}deg) translateX(${-translateX}px) translateY(${-translateY}px)`;
      });
      
      // 更新視頻播放器尺寸
      this.updateVideoPlayerSize();
    }
  },
};
</script>
<style lang="sass" scoped>
</style>
